// const homeRteContent = '{ "blocks": [], "entityMap": {} }';
const homeRteContent =
  '{"blocks":[{"key":"ch34j","text":"A breathing and wellbeing programme for people recovering from the effects of COVID-19","type":"header-two","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}';
export default homeRteContent;
